<template>
  <div class="floating-sidebar-trigger">
    <!-- Hoverable Sidebar Menu -->
    <div
      class="sidebar-menu"
      :style="topMarginStyle"
      data-bs-toggle="offcanvas"
      data-bs-target="#uploadCanvas"
      aria-controls="uploadCanvas"
      @click.prevent
    >
      <!-- Icon -->
      <div class="icon-wrapper">
        <img
          v-if="uploadConfigs.action === 'transform'"
          src="../../assets/icons/xml-icon.svg"
          alt="Transform"
          class="menu-icon"
        />
        <img
          v-else-if="uploadConfigs.action === 'bulk_process'"
          src="../../assets/icons/zip.png"
          alt="Bulk Process"
          class="menu-icon"
        />
      </div>

      <!-- Label (appears on hover) -->
      <span class="menu-label">{{ uploadConfigs.title }}</span>
    </div>
  </div>

  <!-- Offcanvas -->
  <div
    class="offcanvas offcanvas-end"
    data-bs-backdrop="true"
    tabindex="-1"
    id="uploadCanvas"
    aria-labelledby="uploadCanvasLabel"
  >
    <div class="offcanvas-header">
      <h3 class="offcanvas-title" id="uploadCanvasLabel">
        {{ uploadConfigs.title }}
      </h3>
<!-- Custom SVG Close Button -->
<button
  type="button"
  class="custom-close-btn"
  data-bs-dismiss="offcanvas"
  aria-label="Close"
>
  <svg
    class="close-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
</button>

    </div>
    <div v-if="uploadConfigs.action === 'bulk_process'" class="offcanvas-body">
      <SingleFileUploadTemplate :upload-configs="uploadConfigs" />
    </div>
    <div v-else class="offcanvas-body">
      <UploadTemplate :upload-configs="uploadConfigs" />
    </div>
  </div>
</template>
<script>
import UploadTemplate from "../UploadTemplate.vue";
import SingleFileUploadTemplate from "../SingleFileUploadTemplate.vue";
import { pageViews } from "../../utils/util";

export default {
  name: pageViews.CANVASVIEW,
  props: {
    uploadConfigs: {
      type: Object,
      required: true,
    },
  },
  computed: {
    topMarginStyle() {
      const top =
        this.uploadConfigs.action === "bulk_process" ? "3.0rem" : "5.9rem";
      return { top };
    },
  },
  components: {
    UploadTemplate,
    SingleFileUploadTemplate,
  },
};
</script>
<style scoped>
/* Floating Trigger Container */
.floating-sidebar-trigger {
  position: fixed;
  right: 0;
  top: 3%;
  z-index: 1000;
  pointer-events: none;
}

/* Main Menu Bar */
.sidebar-menu {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 0 10px 10px;
  background: linear-gradient(135deg, #696cff, #696cff);
  border-radius: 10px 0 0 10px;
  box-shadow: 0 8px 20px rgba(255, 119, 0, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  pointer-events: auto;
  backdrop-filter: blur(8px);
}

/* Hover: Expand + Glow */
.sidebar-menu:hover {
  width: 150px;
  background: var(--text-primary);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

/* Icon Wrapper */
.icon-wrapper {
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  width: 18px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: rgba(255, 255, 255, 0.9); */
  border-radius: 10px;
  padding: 4px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.sidebar-menu:hover .icon-wrapper {
  transform: rotate(360deg) scale(1.1);
  /* background: #696cff; */
  box-shadow: 0 4px 12px rgba(255, 119, 0, 0.3);
}

/* Icon */
.menu-icon {
  width: 25px;
  height: 25px;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
  transition: filter 0.3s ease;
}


/* Label */
.menu-label {
  margin-left: 12px;
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--body-bg);
  white-space: nowrap;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-menu:hover .menu-label {
  opacity: 1;
  transform: translateX(0);
}

.offcanvas{
  background: var(--surface);
  color: #fff;
}

.custom-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--surface);
  cursor: pointer;
  transition: all 0.2s ease;
}

.custom-close-btn:hover {
  background: var(--surface-hover);
}

.custom-close-btn:active {
  transform: scale(0.95);
}

.close-icon {
  stroke: var(--text-primary);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  transition: stroke 0.25s ease;
}

/* Optional hover effect */
.custom-close-btn:hover .close-icon {
  stroke: var(--primary);
}

.offcanvas-header{
  display: flex;
  justify-content: space-between;
}

.offcanvas-title{
  color: var(--text-primary);
}


/* Pulse Animation on Load */
@keyframes pulse {
  0% {
    box-shadow: 0 8px 20px rgba(133, 147, 255, 0.709);
  }
  50% {
    box-shadow: 0 12px 30px rgba(126, 111, 255, 0.387);
  }
  100% {
    box-shadow: 0 8px 20px rgba(68, 62, 255, 0.855);
  }
}

.sidebar-menu {
  animation: pulse 2s infinite;
}

/* Responsive: Large Screens */
@media (min-width: 1920px) and (min-height: 1080px) {
  .sidebar-menu {
    width: 64px;
    height: 64px;
  }
  .sidebar-menu:hover {
    width: 220px;
  }
  .icon-wrapper {
    width: 38px;
    height: 38px;
  }
  .menu-icon {
    width: 24px;
    height: 24px;
  }
}
</style>
